import { Box } from '@mui/material';
import CompliancePanel from './Components/CompliancePanel';
import CurrentlyDisplayedCard from './Components/CurrentlyDisplayed/Components/CurrentlyDisplayedCard';
import HistoryPanel from './Components/HistoryPanel';
import PanelTabs from './Components/PanelTabs';
import StyledBox from './styles';

interface SessionPanelProps {
  tab: { index: number, updatedAt: number };
  setTab: (value: { index: number, updatedAt: number }) => void;
}

export default function SessionPanel(props: SessionPanelProps) {
  const { tab, setTab } = props;
  return (
    <StyledBox>
      <CurrentlyDisplayedCard />
      <Box className="tabsPanel">
        <PanelTabs
          index={tab.index}
          setIndex={(newValue: number) => { setTab({ index: newValue, updatedAt: Date.now() }); }}
        />
        <Box className="content">
          {tab.index === 0 && <HistoryPanel />}
          {tab.index === 1 && <CompliancePanel />}
        </Box>
      </Box>
    </StyledBox>
  );
}
